import { Field, VStack } from '@chakra-ui/react';
import { InputField } from '@themes/aegix';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const ResetPassowordForm = () => {
  const { t } = useTranslation();
  const { register, formState: { errors } } =
    useFormContext<{ password: string; confirm_password: string }>();
  return (
    <VStack gap={4} align="stretch">
      <Field.Root invalid={!!errors.password}>
        <Field.Label htmlFor="reset-password">{t('common.password', 'Password')}</Field.Label>
        <InputField
          id="reset-password"
          placeholder={t('common.password', 'Password')}
          type="password"
          data-e2e="reset-password-input"
          {...register('password')}
          aria-describedby={errors.password ? 'reset-password-error' : undefined}
        />
        {errors.password && (
          <Field.ErrorText id="reset-password-error" data-e2e="reset-password-error">
            {errors.password.message ? t(errors.password.message) : null}
          </Field.ErrorText>
        )}
      </Field.Root>
      <Field.Root invalid={!!errors.confirm_password}>
        <Field.Label htmlFor="reset-confirm-password">{t('common.confirmPassword', 'Confirm Password')}</Field.Label>
        <InputField
          id="reset-confirm-password"
          placeholder={t('common.confirmPassword', 'Confirm Password')}
          type="password"
          data-e2e="reset-confirm-password-input"
          {...register('confirm_password')}
          aria-describedby={errors.confirm_password ? 'reset-confirm-password-error' : undefined}
        />
        {errors.confirm_password && (
          <Field.ErrorText id="reset-confirm-password-error" data-e2e="reset-confirm-password-error">
            {errors.confirm_password.message ? t(errors.confirm_password.message) : null}
          </Field.ErrorText>
        )}
      </Field.Root>
    </VStack>
  );
};
